import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "@zesty-io/material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
export type DirtyCodeModal = {
  title: string;
  content: string;
  open: boolean;
  loading: boolean;
  saveDisabled?: boolean;
  onCancel: () => void;
  onSave: () => void;
  onDiscard: () => void;
};
export const DirtyCodeModal: FC<DirtyCodeModal> = ({
  title,
  content,
  open,
  loading,
  saveDisabled = false,
  onCancel,
  onSave,
  onDiscard
}) => {
  const {
    t
  } = useTranslation();
  return <ConfirmDialog title={<Typography variant="h5" component="span">
          {title}
        </Typography>} content={<Typography variant="body2" component="span">
          {content}
        </Typography>} open={open} callback={() => {} /* TODO fix dialog in DS lib */} maxWidth="xs" fullWidth data-sentry-element="ConfirmDialog" data-sentry-component="DirtyCodeModal" data-sentry-source-file="DirtyCodeModal.tsx">
      <Stack data-cy="DirtyCodeModal" direction="row" sx={{
      alignItems: "flex-start",
      flexDirection: "row",
      justifyContent: "space-between",
      textDecoration: "none",
      flex: 1,
      margin: "8px"
    }} data-sentry-element="Stack" data-sentry-source-file="DirtyCodeModal.tsx">
        <Button data-cy="DirtyCodeModalCancel" variant="text" onClick={onCancel} color="inherit" disabled={loading} sx={{
        alignSelf: "flex-start",
        textDecoration: "none"
      }} data-sentry-element="Button" data-sentry-source-file="DirtyCodeModal.tsx">
          {t("common.cancel")}
        </Button>
        <Stack direction="row" sx={{
        gap: "8px"
      }} data-sentry-element="Stack" data-sentry-source-file="DirtyCodeModal.tsx">
          <Button data-cy="DirtyCodeModalDiscard" variant="text" color="primary" disabled={loading} onClick={onDiscard} data-sentry-element="Button" data-sentry-source-file="DirtyCodeModal.tsx">
            {t("common.discard")}
          </Button>
          <Button data-cy="DirtyCodeModalSave" variant="contained" color="primary" disabled={loading || saveDisabled} onClick={onSave} data-sentry-element="Button" data-sentry-source-file="DirtyCodeModal.tsx">
            {t("common.save")}
          </Button>
        </Stack>
      </Stack>
    </ConfirmDialog>;
};